<template lang="pug">
GreyPage
  .upsert-page.w-1050
    .title-bar.mb-XL
      h1.h1(data-test-id="title") {{ title }}
      .upsert-buttons-holder
        BriqButton.cancel(v-if="!hideCancel" variant="text" @click="$emit('cancel')" :disabled="pending") Cancel
        BriqViewAuditTrail(v-if="showAuditTrail" :objectType="objectType" :objectKey="objectKey")
        BriqSubmitButton(
          v-if="canSubmit"
          data-test-id="submit-button"
          :disabled="disableSave"
          :pending="pending"
          @click="!pending && $emit('save')"
          ) {{ saveLabel }}
    slot
    .buttons-bottom
      BriqButton.cancel(v-if="!hideCancel" variant="text" @click="$emit('cancel')" :disabled="pending") Cancel
      BriqSubmitButton(
        data-test-id="submit-button-2"
        :disabled="disableSave"
        :pending="pending"
        @click="!pending && $emit('save')"
        ) {{ saveLabel }}
</template>

<script>
export default {
  props: {
    title: String,
    disabled: Boolean,
    canSave: {
      type: Boolean,
      default: true,
    },
    canSubmit: {
      type: Boolean,
      default: true,
    },
    saveLabel: {
      type: String,
      default: 'Save changes',
    },
    hideCancel: Boolean,
    pending: Boolean,
    showAuditTrail: Boolean,
    objectType: String, // todo: rename to auditTrailObjectType
    objectKey: String, // todo: rename to auditTrailObjectKey
  },
  computed: {
    disableSave() {
      return this.disabled || !this.canSave || this.pending
    },
  },
}
</script>

<style scoped lang="stylus">
.title-bar
  display flex
  justify-content space-between
  align-items center

.buttons-bottom
  display flex
  justify-content center

.upsert-buttons-holder
  display flex

  > *
    margin 0px 5px 0px 5px
</style>
